import { CaviarColors, CaviarOverrides } from './caviar';
import { MerchantOverrides } from './merchant'; // Themes: Overrides Sets

var Themes = {
  Caviar: CaviarOverrides,
  Merchant: MerchantOverrides
};
export { CaviarColors, Themes };